import React from "react";

import useGetWindowWidth from "../../../../utils/useGetWindowWidth";

import { BsCheck, BsX } from "react-icons/bs";
import { CgArrowRight } from "react-icons/cg";
import styles from "./styles.module.scss";
import { RouteOwnCollectStatusEnum } from "../../../../enums/RouteOwnCollectStatusEnum";

export function CardOwnCollectStage({ cardData, type, last }) {
  const widthWindows = useGetWindowWidth();

  const isMobile = widthWindows < 769;

  const handleDescription = (cardData) => {
    return cardData?.description?.split("/");
  }

  const description = handleDescription(cardData);

  const handleStatusColor = (status = null) => {
    const color = {
      "Não coletada": "#FF6B71",
      "Erro na coleta": "#FF6B71",
      "Cancelada": "#FF6B71",
    };

    if (color[status] && last) {
      return color[status];
    }

    return last ? "#409e6a" : "#B3B3B3";
  };

  const handleErrorStatus = status => {
    const statusError = [
      "Não coletada",
      "Erro na coleta",
      "Cancelada",
    ];

    return statusError.includes(status) ? true : false;
  };

  const isError = handleErrorStatus(cardData?.status)

  const allStatusData = Object.entries(RouteOwnCollectStatusEnum).find(s =>
    s[1].id === cardData?.statusId
  )

  const statusDescription = allStatusData?.length ? allStatusData[1].message : ""

  return (
    <>
      <div
        className={`${styles.cardObject} ${type === "inactive" ? styles.inactive : ""
          }`}
      >
        <div
          style={{ backgroundColor: handleStatusColor(cardData?.status) }}
          className={styles.iconTimeline}
        >
          {isError && last
            ? <BsX />
            : isMobile && cardData?.icon
              ? cardData?.icon
              : <BsCheck />
          }
          {isMobile && !last &&
            <>
              <div className={styles.dot}></div>
              <div className={styles.dot2}></div>
              <div className={styles.dot3}></div>
            </>
          }
        </div>
        {!last && <span className={`${styles.timeline}`}></span>}
        <div
          style={{ color: last ? "" : "#B3B3B3" }}
          className={styles.cardContent}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px"
            }}
          >
            <p
              style={{ color: handleStatusColor(cardData?.status) }}
              className={styles.status}
            >
              {cardData?.correiosDescription || cardData?.status}
            </p>
            {window.screen.width > 769 && cardData?.date && "-"}
            <p
              style={{
                color:
                  isError &&
                    last
                    ? "#FF6B71"
                    : ""
              }}
            >
              {cardData?.date}
            </p>
            -
            {description.length > 1 ? (
              <div>
                <div
                  style={{
                    color:
                      isError && last
                        ? "#FF6B71"
                        : ""
                  }}
                  className={styles.description}
                >
                  <p>{description[0]}</p>
                  <CgArrowRight className={styles.descriptionSvg} />
                  <p>{description[1]}</p>
                </div>
              </div>
            ) : (
              <div
                style={{
                  color:
                    isError &&
                      last
                      ? "#FF6B71"
                      : ""
                }}
                className={styles.description}
              >
                <p>{description[0] || cardData?.correiosDescription}</p>
              </div>
            )}
          </div>
          {isError && (
            <div className={styles.address}>
              <span
                style={{
                  color:
                    isError &&
                      last
                      ? "#FF6B71"
                      : ""
                }}
              >
                {statusDescription}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
